import React from 'react';
import { useContext, useEffect } from 'react';
import SimpleContext from './../../context/SimpleContext';
import "./TarhDarDrawer.css";
import { Col, Row } from 'react-bootstrap';
import TarhDarDrawerMiniPrd from './TarhDarDrawerMiniPrd';


const TarhDarDrawer = () => {

    const context = useContext(SimpleContext);
    let tarhDarDrawer = 'TarhDarDrawerMain';
    if (context.TarhdarDrawer){
        tarhDarDrawer = 'TarhDarDrawerMain open';
    }
    return ( 
        
        <div  className={tarhDarDrawer} >
            <div className="top_TarhDarDrawer" onClick={context.handleTarhdarDrawer}>
                <Row className="Row">
                    <i className="fa fa-chevron-up" style={{marginTop:"3%"}}></i>
                </Row>
                <Row className="top_TarhDarDrawerRow">
                    <Col className="top_TarhDarDrawerCol1 Col">
                        <p>کالاهای طرح {context.TarhNameHeader} </p>
                    </Col>
                    <Col className="top_TarhDarDrawerCol2">
                        <p>خریداری شده: {context.SumTarh}</p>
                    </Col>
                </Row>
            </div>
                <div className="TarhdarHolder">
                    {
                        context.loopArr.length ? 
                        context.loopArr.map(prd =>
                            prd.map(pt=>
                                <TarhDarDrawerMiniPrd
                                    name = {pt.name}
                                    price = {pt.price}
                                    userPrice = {pt.user_price}
                                    slug = {pt.slug}
                                    min = {pt.minimum}
                                    max = {pt.maximum}
                                    proid = {pt.brandID}
                                    isSahmiyeh = {pt.sahmie_bandi}
                                    isvalid = {pt.status}
                                    numUnit = {pt.number_in_unit}
                                    numSale = {pt.number_in_sale}
                                    unit = {pt.unit}
                                    stock={pt.stock}
                                    category={pt.category}
                                    ulImg={pt.ULImg}
                                    dlImg={pt.DLImg}
                                    urImg={pt.URImg}
                                    drImg={pt.DRImg}
                                    mojud={pt.FreshStatus}
                                    goodsRef={pt.goods_ref}
                                    uniqueid={pt.unique_id}
                                    Role={pt.Role}
                                />   
                            )
                        ):null
                    }

            </div>
        </div>
  
     );
}
 
export default TarhDarDrawer;